
import React from "react";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { BrandTab } from "@/components/admin/settings/BrandTab";
import { useAdminSettings } from "@/hooks/useAdminSettings";
import { Skeleton } from "@/components/ui/skeleton";

const AdminBrand = () => {
  const { settings, isSaving, isLoading, saveSettings, updateSettings } = useAdminSettings();

  if (isLoading) {
    return (
      <AdminLayout title="Brand Settings">
        <div className="space-y-4 w-full">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-[450px] w-full" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Brand Settings">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Brand Settings</h1>
      </div>
      
      <BrandTab
        settings={settings}
        updateSettings={updateSettings}
        saveSettings={saveSettings}
        isSaving={isSaving}
      />
    </AdminLayout>
  );
};

export default AdminBrand;
